var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightpaginationarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 39,
    height: 35,
    rx: 3.5,
    transform: "matrix(-1 0 0 1 39 0)",
    fill: "#FFC300"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 39,
    height: 35,
    rx: 3.5,
    transform: "matrix(-1 0 0 1 39 0)",
    stroke: "#E9E9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7691 14.1841C17.5394 14.423 17.5468 14.8028 17.7857 15.0325L20.9359 18L17.7857 20.9675C17.5468 21.1972 17.5394 21.577 17.7691 21.8159C17.9987 22.0547 18.3786 22.0622 18.6174 21.8325L22.2174 18.4325C22.3351 18.3194 22.4016 18.1632 22.4016 18C22.4016 17.8368 22.3351 17.6806 22.2174 17.5675L18.6174 14.1675C18.3786 13.9378 17.9987 13.9453 17.7691 14.1841Z",
    fill: "#344051"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightpaginationarrow);
export default __webpack_public_path__ + "static/media/rightpaginationarrow.eecaf3e8baf9e91edbde37ad057e886d.svg";
export { ForwardRef as ReactComponent };